import React, { useState, useEffect } from 'react';
import '../styles/Header.css';

export default function Header({ onToggle }) {
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        let lastScrollY = window.scrollY;

        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            const goingDown = currentScrollY > lastScrollY && currentScrollY > 50;

            setIsVisible(!goingDown);
            onToggle && onToggle(!goingDown);

            lastScrollY = currentScrollY;
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [onToggle]);

    return (
        <div className={`header-bar ${isVisible ? 'visible' : 'hidden'}`}>
            <div className="header-container">
                <div className="opening-hours">
                    <span>Montag – Freitag: 11:30 – 22:00 Uhr</span>
                    <span className="separator"> | </span>
                    <span>Samstag, Sonntag & Feiertage: 12:00 – 22:00 Uhr</span>
                </div>
                <div className="contact-info">
                    <span>info@hello-charge-restaurant.de</span>
                    <span className="separator"> | </span>
                    <span>03081098009</span>
                    <span className="separator"> | </span>
                    <span>Huttenstraße 68, 10553 Berlin</span>
                </div>
            </div>
        </div>
    );
}
